(function () {
  function ready(fn) { if (document.readyState !== 'loading') fn(); else document.addEventListener('DOMContentLoaded', fn); }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  function previewParam() { var m = location.search.match(/preview_theme_id=(\d+)/); return m ? '&preview_theme_id=' + m[1] : ''; }

  /* Data loading. The section's inline script (rb-filter-preview.liquid) starts every feed page in
     parallel while the page is still parsing (window.RBF_PRE). Results are cached per collection in
     localStorage: a cached list shows instantly and is refreshed in the background after 10 minutes. */
  var CACHE_V = 'rbf6-', FRESH = 10 * 60 * 1000, MAX_AGE = 24 * 60 * 60 * 1000;
  /* clear the older cache version (rbf3 lists ignored hand-ordered collections like Trending Now) */
  try { Object.keys(localStorage).forEach(function (k) { if (k.indexOf('rbf3-') === 0 || k.indexOf('rbf4-') === 0 || k.indexOf('rbf5-') === 0) localStorage.removeItem(k); }); } catch (e) {}
  function readCache(handle) {
    try { var c = JSON.parse(localStorage.getItem(CACHE_V + handle) || 'null'); if (c && c.items && Date.now() - c.t < MAX_AGE) return c; } catch (e) {}
    return null;
  }
  function writeCache(handle, items) {
    var v = JSON.stringify({ t: Date.now(), items: items });
    try { localStorage.setItem(CACHE_V + handle, v); return; } catch (e) {}
    /* full: drop other collections' lists and try once more */
    try { Object.keys(localStorage).forEach(function (k) { if (k.indexOf(CACHE_V) === 0 && k !== CACHE_V + handle) localStorage.removeItem(k); }); localStorage.setItem(CACHE_V + handle, v); } catch (e) {}
  }
  function fetchPage(handle, page) {
    return fetch('/collections/' + handle + '?view=rb-filter-data&sort_by=' + (window.RBF_SORT || 'best-selling') + '&page=' + page + previewParam()).then(function (r) {
      if (!r.ok) throw new Error('HTTP ' + r.status); return r.json();
    });
  }
  function startPages(handle, total) {
    var pre = window.RBF_PRE;
    if (pre && pre.handle === handle && pre.pages) return pre.pages;
    var n = Math.max(1, Math.min(30, Math.ceil((total || 1) / 250))), out = [];
    for (var i = 1; i <= n; i++) out.push(fetchPage(handle, i));
    return out;
  }
  /* onFirst(items) gets the first 250 best sellers as soon as they arrive; resolves with everything. */
  async function loadBooks(handle, total, onFirst) {
    var cached = readCache(handle);
    if (cached) {
      if (Date.now() - cached.t > FRESH) fetchAll(handle, total).then(function (items) { writeCache(handle, items); }).catch(function () {});
      return cached.items;
    }
    return fetchAll(handle, total, onFirst).then(function (items) { writeCache(handle, items); return items; });
  }
  async function fetchAll(handle, total, onFirst) {
    var pages = startPages(handle, total);
    if (onFirst) pages[0].then(function (j) { onFirst(j.items); }).catch(function () {});
    var res = await Promise.all(pages), items = [];
    res.forEach(function (j) { items = items.concat(j.items); });
    /* the count was out of date (products added since the page rendered): keep going */
    var page = res.length;
    while (res[res.length - 1].next && page < 30) { page++; var j = await fetchPage(handle, page); res.push(j); items = items.concat(j.items); }
    return items;
  }
  window.RB_LOAD_BOOKS = loadBooks;
  try { if (!document.getElementById('rbf-coming-css')) document.head.insertAdjacentHTML('beforeend', '<style id="rbf-coming-css">.rbf-coming{margin-top:.15rem;font-size:.85em;font-weight:700;letter-spacing:.02em;color:#7d7254;line-height:1.3}</style>'); } catch (e) {}

  /* ---------- book card (Oct 12: title big, author underneath linked to the author page) ----------
     The card is a box with a stretched link (so the whole card still opens the book) and a separate
     author link on top of it — a link can't sit inside another link. */
  function byline(b) {
    if (!b.au || !b.au.length) return '';
    var q = previewParam().replace('&', '?');
    var parts = b.au.map(function (a) { return a.u ? '<a href="' + esc(a.u) + q + '">' + esc(a.n) + '</a>' : esc(a.n); });
    var txt = parts.length > 1 ? parts.slice(0, -1).join(', ') + ' &amp; ' + parts[parts.length - 1] : parts[0];
    return '<div class="rbf-by">' + txt + '</div>';
  }
  function titleOf(b) { return b.bt || b.t; }
  /* Preorders (Oct 29): "Coming Jan 12" under the price, from the release-YYYY-MM-DD tag (same as the author pages).
     A preorder = tagged "preorder" or "preorder" in the title; only future dates show. */
  var MON = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
  function comingHtml(b) {
    var tg = b.tg || [], tl = String(b.t || '').toLowerCase();
    if (tg.indexOf('preorder') < 0 && tl.indexOf('preorder') < 0 && tl.indexOf('pre-order') < 0) return '';
    var r = ''; tg.forEach(function (x) { if (/^release-\d{4}-\d{2}-\d{2}$/.test(x)) r = x.slice(8); });
    if (!r) return '';
    var y = +r.slice(0, 4), m = +r.slice(5, 7), d = +r.slice(8, 10), now = new Date();
    if (y * 10000 + m * 100 + d < now.getFullYear() * 10000 + (now.getMonth() + 1) * 100 + now.getDate()) return '';
    return '<div class="rbf-coming">Coming ' + MON[m - 1] + ' ' + d + '</div>';
  }
  function cardHtml(b, lazy, extra) {
    var t = titleOf(b);
    return '<div class="rbf-card"><a class="rbf-card__link" href="' + esc(b.u) + previewParam().replace('&', '?') + '" aria-label="' + esc(t) + '"></a>' +
      '<div class="rbf-img">' + (b.i ? '<img' + (lazy ? ' loading="lazy"' : '') + ' src="' + esc(b.i) + '" alt="' + esc(t) + '">' : '') + (!b.a ? '<span class="rbf-sold">Sold out</span>' : '') + '</div>' +
      '<div class="rbf-t">' + esc(t) + '</div>' + byline(b) + '<div class="rbf-p">' + esc(b.p) + '</div>' + comingHtml(b) + (extra || '') + '</div>';
  }

  ready(function () {
    var root = document.querySelector('[data-rbf-root]');
    if (!root || !window.RB_FILTERS) return;
    var F = window.RB_FILTERS, groups = F.groups;
    var gByKey = {}; groups.forEach(function (g) { gByKey[g.key] = g; });
    var bar = root.querySelector('[data-rbf-bar]'), activeEl = root.querySelector('[data-rbf-active]');
    var countEl = root.querySelector('[data-rbf-count]'), grid = root.querySelector('[data-rbf-grid]');
    var moreBtn = root.querySelector('[data-rbf-more]'), tryEl = root.querySelector('[data-rbf-try]');
    var modeBtn = root.querySelector('[data-rbf-mode]');
    var sortEl = root.querySelector('[data-rbf-sort]'), side = root.querySelector('[data-rbf-side]');
    var openBtn = root.querySelector('[data-rbf-open]'), openN = root.querySelector('[data-rbf-open-n]');
    var layout = root.dataset.layout || 'bar';
    var pills = root.classList.contains('rbf--pills');
    /* pill style shows spice as peppers: '3 – Spicy' -> '🌶🌶🌶 Spicy' */
    function label(g, val) {
      if (!pills || g.key !== 'spice') return val;
      var m = String(val).match(/^(\d)\s*–\s*(.*)$/);
      if (!m) return val;
      var n = +m[1];
      return n ? new Array(n + 1).join('🌶') + ' ' + m[2] : m[2];
    }
    /* sidebar = progressive: every section available, long ones show a few + "more" (no Basic/Advanced switch) */
    var prog = layout === 'side';
    var expandSet = new Set(), SHORT = 8, hideGenre = false, fantasyPage = false;
    /* Set orders for long lists (Jordan, Oct 11). The sidebar shows the first 8 and puts the rest under "more".
       Before: the 8 options with the most books, which buried what online shoppers look for (kids' books
       outnumber LGBTQ+ but sell in the shop, not online). Options with fewer than 5 books on the page drop
       to the end, so e.g. creatures don't crowd a contemporary page. Seasonal settings lead in season
       and go to the end out of season. */
    var ORDER = {
      genre: ['Romantasy', 'Dark Fantasy Romance', 'Contemporary Romance', 'Dark Romance', 'Sports Romance', 'LGBTQ+ Romance', 'Paranormal Romance', 'Cowboy Romance', 'Historical Romance', 'Young Adult', 'Classics & Literary Fiction', "Children's"],
      characters: ['Fae', 'Vampires', 'Werewolves & Shifters', 'Witches', 'Dragons', 'Monsters & Demons', 'Morally Gray', 'Billionaire', 'Royals', 'Gods & Mythology', 'Bad Boy', 'Obsessed Hero', 'Cinnamon Roll Hero', 'Celebrity / Rockstar', 'Pirates', 'Touch Her and Die'],
      setting: ['Small Town', 'Hockey', 'Dark Academia', 'Mafia', 'College', 'Workplace', 'Court Intrigue', 'Retellings & Fairytales', 'Romantic Suspense', 'Mystery', 'Gothic', 'Military', 'Dystopian', 'Motorcycle Club'],
      rep: ['Black', 'Latine', 'Asian', 'Sapphic', 'MM', 'Bisexual', 'Curvy / Plus-Size', 'Neurodivergent', 'Trans', 'Midlife / Over 40', 'Disability', 'Mental Health', 'South Asian', 'Ace & Demi', 'Polyamory', 'Multicultural', 'Indigenous', 'Caribbean', 'Jewish', 'Muslim']
    };
    var SEASONS = { 'Halloween & Spooky': [901, 1031], 'Christmas': [1101, 1231], 'Summer Reads': [515, 831] }; /* month*100 + day */
    var MIN_SHOW = 5, pageCounts = {};
    function inSeason(v) { var s = SEASONS[v]; if (!s) return null; var d = new Date(), md = (d.getMonth() + 1) * 100 + d.getDate(); return md >= s[0] && md <= s[1]; }
    function orderCmp(key) {
      var list = ORDER[key]; if (!list) return null;
      var pc = pageCounts[key] || {};
      function rank(v) {
        var s = inSeason(v.v);
        if (s === true) return -1;
        if (s === false) return 2000;
        var i = list.indexOf(v.v); if (i < 0) i = 99;
        return ((pc[v.v] || 0) < MIN_SHOW ? 1000 : 0) + i;
      }
      return function (a, b) { return rank(a) - rank(b); };
    }
    var books = [], sel = {}, shown = 48, openKey = null, sortBy = 'best';
    var openSet = new Set(F.open || ['genre', 'spice']); /* sidebar: only Genre and Spice open by default (Jordan, Oct 10) so every section name is visible without scrolling */
    function isOpen(k) { return layout === 'side' ? openSet.has(k) : openKey === k; }
    function priceOf(b) { var n = parseFloat(String(b.p || '').replace(/[^0-9.]/g, '')); return isNaN(n) ? 0 : n; }
    function sorted(list) {
      if (sortBy === 'best') return list;
      var out = list.slice();
      if (sortBy === 'az') out.sort(function (a, b) { return titleOf(a).localeCompare(titleOf(b)); });
      if (sortBy === 'low') out.sort(function (a, b) { return priceOf(a) - priceOf(b); });
      if (sortBy === 'high') out.sort(function (a, b) { return priceOf(b) - priceOf(a); });
      return out;
    }

    /* ---------- one card per book (Jordan, Oct 11) ----------
       Editions are separate products linked by custom.editions; the feed gives each edition group a key (e)
       and its label (f). Results show one card per group: the first in-stock edition in the current sort
       order (else the first one), with "Also in …" naming the other editions. Counts count each book once. */
    var edAll = {}; /* group key -> all editions on this page */
    function edKey(b) { return b.e ? 'e' + b.e : 'h' + b.h; }
    function collapse(list) {
      var pick = {}, out = [];
      list.forEach(function (b) { if (!b.e) return; var k = edKey(b); if (!pick[k] || (!pick[k].a && b.a)) pick[k] = b; });
      list.forEach(function (b) { if (!b.e || pick[edKey(b)] === b) out.push(b); });
      return out;
    }
    function alsoIn(b) {
      var g = b.e ? edAll[edKey(b)] : null; if (!g || g.length < 2) return '';
      var others = g.filter(function (x) { return x !== b; }).map(function (x) { return x.f || 'another edition'; });
      others = others.filter(function (v, i) { return others.indexOf(v) === i; });
      return '<div class="rbf-ed">Also in ' + esc(others.join(', ')) + '</div>';
    }

    /* ---------- mode: basic (default) or advanced ---------- */
    var params = new URLSearchParams(location.search);
    var mode = params.get('rbm') === 'adv' ? 'advanced' : null;
    if (!mode) { try { mode = localStorage.getItem('rbf-mode'); } catch (e) {} }
    if (mode !== 'advanced') mode = 'basic';

    groups.forEach(function (g) { sel[g.key] = new Set(); });
    params.getAll('rbf').join('~').split('~').forEach(function (p) {
      var i = p.indexOf('|'); if (i < 0) return;
      var k = p.slice(0, i), v = p.slice(i + 1); if (sel[k]) sel[k].add(v);
    });

    function isReq(k, val) { var v = gByKey[k].values.filter(function (x) { return x.v === val; })[0]; return !!(v && v.require); }
    function isBasicValue(g, v) { return !g.advanced && (g.key !== 'tropes' || v.basic); }
    function needsAdvanced() {
      return groups.some(function (g) {
        var adv = false;
        sel[g.key].forEach(function (val) { var v = g.values.filter(function (x) { return x.v === val; })[0]; if (v && !isBasicValue(g, v)) adv = true; });
        return adv;
      });
    }
    if (needsAdvanced()) mode = 'advanced';
    if (prog) mode = 'advanced';

    function setMode(m) {
      mode = m;
      try { localStorage.setItem('rbf-mode', m); } catch (e) {}
      openKey = null;
      render();
    }

    /* ---------- filtering ---------- */
    function filtered(skip) {
      return books.filter(function (b) {
        if (b.nb) { for (var x in sel) if (x !== 'avail' && x !== skip && sel[x].size) return false; } /* gifts etc. only when not filtering */
        for (var k in sel) {
          if (k === skip || !sel[k].size) continue;
          if (gByKey[k].exclude) {
            if (!F.checked(b)) return false;
            var hit = false; sel[k].forEach(function (v) { if (isReq(k, v) ? !b.m[k].has(v) : b.m[k].has(v)) hit = true; });
            if (hit) return false;
            continue;
          }
          var ok = false; sel[k].forEach(function (v) { if (b.m[k].has(v)) ok = true; });
          if (!ok) return false;
        }
        return true;
      });
    }

    function syncUrl() {
      var u = new URL(location.href), parts = []; u.searchParams.delete('rbf'); u.searchParams.delete('rbm');
      for (var k in sel) sel[k].forEach(function (v) { parts.push(k + '|' + v); });
      if (parts.length) u.searchParams.set('rbf', parts.join('~'));
      if (mode === 'advanced') u.searchParams.set('rbm', 'adv');
      u.searchParams.delete('rbs'); if (sortBy !== 'best') u.searchParams.set('rbs', sortBy);
      history.replaceState(null, '', u);
    }

    /* ---------- quick picks ---------- */
    var tries = {
      basic: [
        ['Spicy enemies to lovers', [['tropes', 'Enemies to Lovers'], ['spice', '3 – Spicy'], ['spice', '4 – Very Spicy']]],
        ['Romantasy + Slow Burn', [['genre', 'Romantasy'], ['tropes', 'Slow Burn']]],
        ['Clean + Second Chance', [['spice', '0 – Clean'], ['spice', '1 – Sweet'], ['tropes', 'Second Chance']]],
        ['Grumpy x Sunshine rom-coms', [['genre', 'Contemporary Romance'], ['tropes', 'Grumpy x Sunshine']]],
        ['Fated Mates', [['tropes', 'Fated Mates']]]
      ],
      advanced: [
        ['Fae + Enemies to Lovers', [['characters', 'Fae'], ['tropes', 'Enemies to Lovers']]],
        ['Slow Burn, no love triangle', [['tropes', 'Slow Burn'], ['leaveout', 'Love triangle']]],
        ['Black rep + Funny', [['rep', 'Black'], ['mood', 'Funny / Rom-Com']]],
        ['Standalone, no third-act breakup', [['series', 'Standalone'], ['mood', 'Confirmed: No Third-Act Breakup']]],
        ['Hockey + Grumpy x Sunshine', [['setting', 'Hockey'], ['tropes', 'Grumpy x Sunshine']]],
        ['Book 1 + Dragons', [['series', 'Book 1 of a Series'], ['characters', 'Dragons']]]
      ]
    };

    tries.prog = [
      ['Spicy enemies to lovers', [['tropes', 'Enemies to Lovers'], ['spice', '3 – Spicy'], ['spice', '4 – Very Spicy']]],
      ['Fae + Slow Burn', [['characters', 'Fae'], ['tropes', 'Slow Burn']]],
      ['Clean romance', [['spice', '0 – Clean'], ['spice', '1 – Sweet']]],
      ['Book 1 of a series', [['series', 'Book 1 of a Series']]]
    ];
    function triesNow() { return prog ? tries.prog : tries[mode]; }
    function renderTries() {
      if (!tryEl) return; /* quick picks only show with the search box */
      var list = triesNow();
      tryEl.innerHTML = '<span>Try:</span> ' + list.map(function (t, i) { return '<button type="button" data-i="' + i + '">' + esc(t[0]) + '</button>'; }).join('');
    }

    /* ---------- render ---------- */
    function render() {
      root.classList.toggle('rbf--advanced', mode === 'advanced');
      if (modeBtn) {
        modeBtn.textContent = mode === 'advanced' ? 'Show fewer filters' : 'Show all filters';
        modeBtn.setAttribute('aria-pressed', mode === 'advanced' ? 'true' : 'false');
      }
      renderTries();

      var html = '';
      groups.forEach(function (g) {
        if (g.advanced && mode !== 'advanced' && !sel[g.key].size) return;
        if (prog && g.key === 'avail') return; /* shown as the In stock switch instead */
        if (prog && g.key === 'genre' && hideGenre && !sel.genre.size) return;
        var pool = filtered(g.key), n = sel[g.key].size;
        var counts = {}; g.values.forEach(function (v) { counts[v.v] = 0; });
        var seenG = {}; g.values.forEach(function (v) { seenG[v.v] = {}; });
        pool.forEach(function (b) { if (b.nb && g.key !== 'avail') return; var k = edKey(b); b.m[g.key].forEach(function (v) { if (!seenG[v][k]) { seenG[v][k] = 1; counts[v]++; } }); });
        var values = g.values.filter(function (v) {
          var on = sel[g.key].has(v.v);
          if (!on && !counts[v.v]) return false; /* hide options with no books here */
          return mode === 'advanced' || isBasicValue(g, v) || on;
        });
        if (!values.length) return;
        var cmp = orderCmp(g.key); if (cmp) values.sort(cmp); /* same order expanded or not */
        var extra = 0;
        if (prog && !expandSet.has(g.key)) {
          var keep;
          if (g.key === 'tropes') keep = values.filter(function (v) { return v.basic || sel[g.key].has(v.v); });
          else if (values.length > SHORT + 2) {
            /* lists with a set order (ORDER) keep it; on fantasy pages the creatures (listed first in the map) lead; elsewhere the biggest options */
            var ranked = (cmp || (g.key === 'characters' && fantasyPage)) ? values.slice() : values.slice().sort(function (a, b) { return counts[b.v] - counts[a.v]; });
            var top = ranked.slice(0, SHORT).map(function (v) { return v.v; });
            keep = values.filter(function (v) { return top.indexOf(v.v) >= 0 || sel[g.key].has(v.v); });
          } else keep = values;
          extra = values.length - keep.length;
          values = keep;
        }
        html += '<details class="rbf-group' + (g.exclude ? ' rbf-group--exclude' : '') + '" data-key="' + g.key + '"' + (isOpen(g.key) ? ' open' : '') + '><summary>' + esc(g.label) + (n ? ' <span class="rbf-badge">' + n + '</span>' : '') + '</summary><div class="rbf-panel">';
        if (g.key === 'rep') html += '<p class="rbf-hint">Main character representation. Author background is under Authors.</p>';
        if (g.exclude) html += '<p class="rbf-hint">Hide books with this content. Based on reader content notes, so it is a guide rather than a guarantee. Books we haven’t checked yet are hidden too while this is on.</p>';
        values.forEach(function (v) {
          var c = counts[v.v], on = sel[g.key].has(v.v);
          var dis = false;
          if (g.exclude && v.require) c = pool.filter(function (b) { return F.checked(b) && !b.m[g.key].has(v.v); }).length;
          var cnt = g.exclude ? (c ? c + ' to hide' : 'on') : c;
          html += '<label class="rbf-opt' + (dis ? ' is-empty' : '') + (on ? ' is-on' : '') + '"><input type="checkbox" data-k="' + g.key + '" value="' + esc(v.v) + '"' + (on ? ' checked' : '') + (dis ? ' disabled' : '') + '> <span>' + (g.exclude ? 'No ' + esc(v.v.charAt(0).toLowerCase() + v.v.slice(1)) : esc(label(g, v.v))) + '</span> <span class="rbf-n">' + (pills ? cnt : '(' + cnt + ')') + '</span></label>';
        });
        if (prog && extra > 0) html += '<button type="button" class="rbf-morepill" data-rbf-expand="' + g.key + '">+ ' + extra + ' more' + (g.key === 'tropes' ? ' tropes' : '') + '</button>';
        else if (prog && expandSet.has(g.key)) html += '<button type="button" class="rbf-morepill" data-rbf-expand="' + g.key + '">Show fewer</button>';
        if (g.key === 'tropes' && mode !== 'advanced') html += '<button type="button" class="rbf-linkbtn" data-rbf-go-adv>Have a very specific type? See every trope →</button>';
        html += '</div></details>';
      });
      bar.innerHTML = html;

      var chips = '';
      groups.forEach(function (g) {
        if (prog && g.key === 'avail') return;
        sel[g.key].forEach(function (v) {
          var lbl = g.exclude ? 'No ' + v.charAt(0).toLowerCase() + v.slice(1) : g.label + ': ' + label(g, v);
          chips += '<button type="button" class="rbf-chip' + (g.exclude ? ' rbf-chip--exclude' : '') + '" data-k="' + g.key + '" data-v="' + esc(v) + '">' + esc(lbl) + ' ✕</button>';
        });
      });
      activeEl.innerHTML = chips ? chips + '<button type="button" class="rbf-clear">Clear all</button>' : '';

      var res = collapse(sorted(filtered(null)));
      var nSel = 0; for (var sk in sel) nSel += sel[sk].size;
      if (openN) openN.textContent = nSel ? '(' + nSel + ')' : '';
      if (stockEl) stockEl.checked = sel.avail.has('In stock');
      var doneBtn = root.querySelector('.rbf-side__done'); if (doneBtn) doneBtn.textContent = 'Show ' + res.length + (F.merch ? ' item' : ' book') + (res.length === 1 ? '' : 's');
      var word = (F.merch || res.some(function (b) { return b.nb; })) ? 'item' : 'book';
      countEl.textContent = res.length + ' ' + word + (res.length === 1 ? '' : 's');
      grid.innerHTML = res.slice(0, shown).map(function (b) {
        return cardHtml(b, true, alsoIn(b));
      }).join('');
      moreBtn.hidden = res.length <= shown;
      syncUrl();
    }

    /* ---------- events ---------- */
    bar.addEventListener('change', function (e) {
      var t = e.target; if (!t.dataset.k) return;
      if (t.checked) sel[t.dataset.k].add(t.value); else sel[t.dataset.k].delete(t.value);
      openKey = t.dataset.k; shown = 48; render();
    });
    bar.addEventListener('click', function (e) {
      if (e.target.closest('[data-rbf-go-adv]')) { e.preventDefault(); setMode('advanced'); }
      var ex = e.target.closest('[data-rbf-expand]');
      if (ex) { e.preventDefault(); var k = ex.dataset.rbfExpand; if (expandSet.has(k)) expandSet.delete(k); else expandSet.add(k); render(); }
    });
    bar.addEventListener('toggle', function (e) {
      if (layout === 'side') { if (e.target.open) openSet.add(e.target.dataset.key); else openSet.delete(e.target.dataset.key); return; }
      if (e.target.open) { openKey = e.target.dataset.key; bar.querySelectorAll('details[open]').forEach(function (d) { if (d !== e.target) d.open = false; }); }
      else if (openKey === e.target.dataset.key) openKey = null;
    }, true);
    document.addEventListener('click', function (e) { if (layout !== 'side' && !bar.contains(e.target)) { openKey = null; bar.querySelectorAll('details[open]').forEach(function (d) { d.open = false; }); } });
    activeEl.addEventListener('click', function (e) {
      var t = e.target;
      if (t.classList.contains('rbf-clear')) { for (var k in sel) sel[k].clear(); }
      else if (t.dataset.k) sel[t.dataset.k].delete(t.dataset.v);
      else return;
      shown = 48; render();
    });
    moreBtn.addEventListener('click', function () { shown += 48; render(); });
    var sp = params.get('rbs'); if (sp && sortEl && sortEl.querySelector('option[value="' + sp + '"]')) { sortBy = sp; sortEl.value = sp; }
    var stockEl = root.querySelector('[data-rbf-stock]');
    if (stockEl) {
      if (!prog) stockEl.closest('label').hidden = true;
      stockEl.checked = sel.avail && sel.avail.has('In stock');
      stockEl.addEventListener('change', function () { sel.avail.clear(); if (stockEl.checked) sel.avail.add('In stock'); shown = 48; render(); });
    }
    if (prog && modeBtn) modeBtn.hidden = true;
    if (sortEl) sortEl.addEventListener('change', function () { sortBy = sortEl.value; shown = 48; render(); });
    function drawer(on) { root.classList.toggle('rbf--drawer-open', on); document.documentElement.classList.toggle('rbf-lock', on); }
    if (openBtn) openBtn.addEventListener('click', function () { drawer(true); });
    root.querySelectorAll('[data-rbf-close]').forEach(function (b) { b.addEventListener('click', function () { drawer(false); }); });
    if (modeBtn) modeBtn.addEventListener('click', function () {
      if (mode === 'advanced') {
        /* going back to Basic keeps only basic picks */
        groups.forEach(function (g) {
          Array.from(sel[g.key]).forEach(function (val) { var v = g.values.filter(function (x) { return x.v === val; })[0]; if (!v || !isBasicValue(g, v)) sel[g.key].delete(val); });
        });
        setMode('basic');
      } else setMode('advanced');
    });
    if (tryEl) tryEl.addEventListener('click', function (e) {
      var i = e.target.dataset.i; if (i == null) return;
      var pick = triesNow()[i];
      for (var k in sel) sel[k].clear();
      pick[1].forEach(function (p) { sel[p[0]].add(p[1]); });
      shown = 48; render();
    });

    function prep(items) {
      return items.map(function (b) {
        b.tg = b.tg || []; b.m = {}; b.nb = !F.merch && !!b.y && b.y !== 'Book'; /* merch pages: every product is a normal result */
        groups.forEach(function (g) { b.m[g.key] = new Set(g.values.filter(function (v) { return F.matches(b, v); }).map(function (v) { return v.v; })); });
        return b;
      });
    }
    var fullLoaded = false, total = parseInt(root.dataset.total, 10) || 0;
    /* first 250 best sellers: show their covers right away while the rest load */
    function showFirst(items) {
      if (fullLoaded) return;
      grid.innerHTML = collapse(items).slice(0, shown).map(function (b) {
        return cardHtml(b, false);
      }).join('');
      if (total) countEl.textContent = total.toLocaleString() + ' ' + (root.dataset.word || 'books');
    }
    loadBooks(root.dataset.collection, total, showFirst).then(function (items) {
      fullLoaded = true;
      books = prep(items);
      edAll = {}; books.forEach(function (b) { if (b.e) (edAll[edKey(b)] = edAll[edKey(b)] || []).push(b); });
      if (!document.getElementById('rbf-ed-css')) document.head.insertAdjacentHTML('beforeend', '<style id="rbf-ed-css">.rbf-ed{font-size:.8em;color:#aa6d6b;margin-top:.15rem;line-height:1.3}</style>');
      /* book counts for the whole page, used by orderCmp (stable while filters change) */
      groups.forEach(function (g) { var c = pageCounts[g.key] = {}; books.forEach(function (b) { if (b.nb) return; b.m[g.key].forEach(function (v) { c[v] = (c[v] || 0) + 1; }); }); });
      if (prog) {
        var gc = {}, nBooks = 0; books.forEach(function (b) { if (b.nb) return; nBooks++; (b.m.genre || []).forEach(function (v) { gc[v] = (gc[v] || 0) + 1; }); });
        var mx = 0; for (var gk in gc) mx = Math.max(mx, gc[gk]);
        hideGenre = nBooks > 0 && mx / nBooks >= 0.9;
        /* fantasy-heavy pages (half or more Romantasy/Paranormal): list the creatures first in
           Characters & Creatures, since those readers browse by Fae, Dragons, Vampires... */
        var nFant = 0; books.forEach(function (b) { if (!b.nb && (b.g === 'Romantasy' || b.g === 'Paranormal Romance')) nFant++; });
        fantasyPage = nBooks > 0 && nFant / nBooks >= 0.5;
      }
      render();
    }).catch(function (err) { bar.innerHTML = '<span class="rbf-loading">Could not load books: ' + esc(err.message) + '</span>'; });
  });
})();
